<template>
  <span>{{ t(`NotificationsComponent.${notification.type}`, { plan: notificationMessage }) }}</span>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from "vue";
import { logEvent } from "@/common/logger";
import { t } from "@/i18n";
import { INotification } from "@/stores/notifications";

const componentName = "MovePaymentMethodMRToARNotification";

export default defineComponent({
  name: componentName,
  props: {
    notification: {
      type: Object as PropType<INotification>,
      required: true,
    },
  },
  setup(props) {
    logEvent("created", componentName);

    const notificationMessage = ref<string>(props.notification?.params?.plan ?? "");
    //Expose to template
    return {
      t,
      notificationMessage,
    };
  },
});
</script>
